import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LogComponent } from './log/log.component';
import { LogsComponent } from './logs.component';


const routes: Routes = [
  {
    path: "", component: LogsComponent ,children:[
   { path: "Logs", component: LogComponent},
      { path: "", redirectTo: 'Logs', pathMatch: 'full'},

 
 ]}
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
exports: [RouterModule]
})
export class LogsRoutingModule { }
